import { RequestParameters, Variables } from 'relay-runtime';

export const getAtlAttributionHeader = (request: RequestParameters, variables: Variables) => {
  const workspaceId = variables['containerId']
    ? variables['containerId']
    : variables['cloudId']
    ? variables['cloudId']
    : '';
  return {
    'atl-attribution': JSON.stringify({
      atlWorkspaceId: workspaceId,
      tenantId: workspaceId, // tenantId (ARI) for the tenant in respective org
      product: 'Atlassian Home', //The product to which the upstream service belongs
      businessUnit: 'Engineering-Atlassian Home', //The business unit to which the upstream service belongs.
      service: 'townsquare-frontend', //Name of the upstream service
      costCenter: 'Engineering-Atlassian Home', //Cost Center of the upstream service,
      team: 'Atlassian Home', // Team name of the upstream service
    }),
  };
};
